import request from "@/utils/request";

// 获取单位信息列表
export const notifymessageinstall = data => {
  return request({
    url: "/apiData/hz-data-community/notify/message/install",
    data: data,
    method: "POST"
  });
};
// 对应的我发布的消息
export const notifymessageMymessage = data => {
  return request({
    url: "/apiData/hz-data-community/notify/message/Mymessage",
    data: data,
    method: "POST"
  });
};
// 未读消息
export const notifymessageunread_message = data => {
  return request({
    url: "/apiData/hz-data-community/notify/message/unread_message",
    data: data,
    method: "POST"
  });
};